import React from "react";
import ResumeForm from "./components/ResumeForm";
import "./styles/ResumeForm.css";

function App() {
    return (
        <div className="app-wrapper">
        <div className="container">
            <h1>
                ATS Resume Generator
                <span 
                    title="ATS (Applicant Tracking System) is software used by 99% of Fortune 500 companies to automatically screen resumes. Most resumes are rejected by ATS before human recruiters ever see them. This tool helps create ATS-friendly resumes that pass automated screening."
                    style={{
                        marginLeft: '8px',
                        fontSize: '0.6em',
                        color: '#007bff',
                        cursor: 'help',
                        border: '1px solid #007bff',
                        borderRadius: '50%',
                        width: '20px',
                        height: '20px',
                        display: 'inline-flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        fontWeight: 'bold',
                        verticalAlign: 'middle'
                    }}
                >
                    ?
                </span>
            </h1>
            <p style={{ 
                color: '#666', 
                fontSize: '0.95em', 
                marginBottom: '30px',
                lineHeight: '1.4'
            }}>
                <strong>What is ATS?</strong> Applicant Tracking Systems automatically scan resumes before human review. 
                <br />
                <strong>Why it matters:</strong> 75% of resumes never reach hiring managers due to ATS filtering.
                <br />
                <strong>Solution:</strong> Generate ATS-optimized resumes that pass automated screening.
            </p>
            <ResumeForm />
            </div>
            <footer className="vexorium-footer">
                <p>
                    Powered by{' '}
                    <a 
                        href="https://www.vexorium.net/" 
                        target="_blank" 
                        rel="noopener noreferrer"
                        className="vexorium-link"
                    >
                        Vexorium Technologies Inc.
                    </a>
                </p>
                <p className="vexorium-tagline">The Future, Empowered.</p>
            </footer>
        </div>
    );
}

export default App;